import React, { ReactChild } from 'react';
import styled, { css } from 'styled-components';
import { colors, fonts } from 'bench-style-constants';

const weightMap = {
  normal: '300',
  medium: '600',
  bold: '700',
};

type TextProps = {
  children: ReactChild;
  size?: 'small' | 'medium' | 'large' | 'xlarge';
  styleType?: 'default' | 'medium' | 'light';
  weight?: 'normal' | 'medium' | 'bold';
  align?: 'center' | 'left' | 'right';
  // eslint-disable-next-line react/require-default-props
  onClick?: (arg0: React.MouseEvent<HTMLDivElement>) => void;
};

const StyledText = styled.p<TextProps>`
  display: block;
  margin: 0;
  color: ${colors.charcoal};
  font-family: ${fonts.circular};
  font-weight: ${({ weight }) => weightMap[weight || 'normal']};
  font-size: 16px;
  line-height: 24px;
  text-align: ${({ align }) => align};

  ${props =>
    props.size === 'small' &&
    css`
      font-size: 12px;
      line-height: 16px;
    `}

  ${props =>
    props.size === 'large' &&
    css`
      font-size: 20px;
      line-height: 32px;
    `}

  ${props =>
    props.size === 'xlarge' &&
    css`
      font-size: 24px;
      line-height: 40px;
    `}

  ${props =>
    props.styleType === 'medium' &&
    css`
      color: ${colors.smoke};
    `}

  ${props =>
    props.styleType === 'light' &&
    css`
      color: ${colors.dust};
    `}
`;

const Text = (props: TextProps) => <StyledText {...props}>{props.children}</StyledText>;

Text.defaultProps = {
  align: 'left',
  size: 'medium',
  styleType: 'default',
  weight: 'normal',
};

export default Text;
